import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Link, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import * as constants from "../../../constants/CONSTANT";
import { useLocation } from "react-router-dom";

import FontAwesome from "react-fontawesome";
import jwt_decode from "jwt-decode";
import "../template/custom.css"; //Added By Pathan

/*********************
 * CP Code
 *******************/
import { PATHS } from "../../../constants/WebRouting";
/*********************
 * CP Code
 *******************/
const getPUBLICURL = () => {
  const tenantCode = sessionStorage?.getItem("schoolcode") ?? "";
  return `https://crm.idigischool.com/`;
};
const Sidebar = () => {
  const navigate = useNavigate();
  const [sidebar, setSidebar] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [permissions, setPermissions] = useState();
  const location = useLocation();

  useEffect(() => {
    try {
      if (sessionStorage.getItem("token")) {
        let user = jwt_decode(sessionStorage.getItem("token"));
        setUserInfo(user);
        var perm = user.permissions
          .map(function (obj) {
            return obj.name;
          })
          .join(";");
        setPermissions(perm);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 401) {
        navigate("/login");
      }
    }
  }, []);

  const toggleSidebar = () => {
    if (sidebar === false) {
      setSidebar(true);
      console.log(sidebar);
      document.querySelector("#sidebar").classList.toggle("active");
    } else {
      setSidebar(false);
      console.log(sidebar);
      document.querySelector("#sidebar").classList.toggle("active");
    }
  };

  return (
    <>
      <nav id="sidebar" className="sidebar card py-2 mb-4">
        {/* left panel logo */}
        <div
          className="sidebar-header text-center"
          style={{ paddingLeft: "0", paddingRight: "0", paddingTop: "10px" }}
        >
          <div className="pb-1">
            <img
              src={`${getPUBLICURL()}${userInfo.tenantcode}-sidebar-logo.png`}
              style={{ width: "125px" }}
              alt=""
            />
          </div>
        </div>

        {/* Tabs List */}
        <ul
          className="nav flex-column list-unstyled components "
          id="tabs_navigation"
          style={{ fontWeight: "bold", borderTop: "1px solid #ddd" }}
        >
          {/* ****************** Home ****************** */}
          <li
            className={`${location.pathname.includes("/home") ? "active" : ""}`}
          >
            <Link to="/home">
              <i className="fa-solid fa-house mx-2"></i> Home
            </Link>
          </li>
          {/* Payments  */}
          <li
            className={`${
              location.pathname.includes("/payments") ? "active" : ""
            }`}
          >
            <Link to="/payments">
              <i class="fa-solid fa-inr mx-2"></i>Payments
            </Link>
          </li>
          <li
            className={`${
              location.pathname.includes("/feeslips") ? "active" : ""
            }`}
          >
            <Link to="/feeslips">
              <i class="fa-solid fa-receipt mx-2"></i>Payments Slips
            </Link>
          </li>
          {/* Assigments  */}
          <li
            className={`${
              location.pathname.includes("/assigments") ? "active" : ""
            }`}
          >
            <Link to="/assigments">
              <i class="fa fa-book mx-2"></i>Assignment
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          {/* Exams  */}
          <li
            className={`${
              location.pathname.includes("/exams") ? "active" : ""
            }`}
          >
            <Link to="/exams">
              <i class="fas fa-graduation-cap mx-2"></i>Exams
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          {/* Results  */}
          <li
            className={`${
              location.pathname.includes("/results") ? "active" : ""
            }`}
          >
            <Link to="/results">
              <i class="fas fa-graduation-cap mx-2"></i>Result
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          {/* Student Attendance */}
          <li
            className={`${
              location.pathname.includes("/studentattendances") ? "active" : ""
            }`}
          >
            <Link to="/studentattendances">
              <i class="fas fa-tasks mx-2"></i>Student Attendance
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          {/* Student Time Table */}
          {/* Added on 23-Feb-2024 Time Table Module */}
          <li
            className={`${
              location.pathname.includes("/timetables") ? "active" : ""
            }`}
          >
            <Link to="/timetables">
              <i class="fas fa-calendar mx-2 mx-2"></i>Time Table
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          <li
            className={`${
              location.pathname.includes("/transport") ? "active" : ""
            }`}
          >
            <Link to="/transport">
              <i class="fa-solid fa-bus mx-2"></i>
              Transport
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          <li
            className={`${
              location.pathname.includes("/announcement") ? "active" : "" //Add by Aamir khan 17/01/2025
            }`}
          >
            <Link to="/announcement">
              <i class="fa fa-bullhorn mx-2"></i>Announcements
              {/* <i class="fa-solid fa-receipt mx-2"></i>Assigments */}
            </Link>
          </li>
          {/* User Profile */}
          <li
            className={`${
              location.pathname.includes("/myprofile") ? "active" : ""
            }`}
          >
            <Link to="/myprofile">
              <i className="fa-solid fa-key mx-2" size={18} />
              My Profile
            </Link>
          </li>
          <li></li>
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
